import React from 'react';
import logos from '../common/Logos';
import theme from '../../theme';

function BrokerLinking({ supportedBrokers, linkedBrokers, onLinkBroker, onOpenVirtualModal }) {
  const handleLinkBroker = (brokerName) => {

    if (brokerName === 'virtual') {
      onOpenVirtualModal();
    } else {
      onLinkBroker(brokerName);
    }
    console.log(`Linking broker: ${brokerName}`);
  };

  return (
    <div>
      <h2 className={`text-xl font-bold mb-4 ${theme.textPrimary}`}>Link Accounts</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {supportedBrokers.map((broker) => {
          var isLinked;
          if (linkedBrokers != null) {
            isLinked = linkedBrokers.some(
              (linkedBroker) => linkedBroker.id === broker.id
            );
          } else { isLinked = false; }
          return (
            <button
              key={broker.id}
              onClick={() => handleLinkBroker(broker.name)}
              className={`flex flex-col items-center p-4 cursor-pointer ${theme.cardBg} ${theme.cardBorder} ${theme.cardRound} ${theme.cardShadow} transition-all duration-200 hover:shadow-md hover:border-olive-300 hover:-translate-y-0.5 active:scale-[0.98]`}
            >
              <img
                src={logos[broker.name]}
                alt={`${broker.name} logo`}
                className="w-16 h-16 mb-2"
              />
              <h3 className={`font-semibold text-center ${theme.textPrimary}`}>{broker.name.toUpperCase()}</h3>
              {isLinked ? (
                <span className="text-olive-700 text-sm font-medium">Linked</span>
              ) : (
                <span className={`${theme.textMuted} text-sm`}>Link</span>
              )}
            </button>
          );
        })}
        <button
          onClick={() => handleLinkBroker('virtual')}
          className={`flex flex-col items-center p-4 cursor-pointer ${theme.cardBg} ${theme.cardBorder} ${theme.cardRound} ${theme.cardShadow} transition-all duration-200 hover:shadow-md hover:border-olive-300 hover:-translate-y-0.5 active:scale-[0.98]`}
        >
          <img
            src={logos.virtual || '/virtual-icon.svg'}
            alt="Virtual account logo"
            className="w-16 h-16 mb-2"
          />
          <h3 className={`font-semibold text-center ${theme.textPrimary}`}>VIRTUAL</h3>
          <span className={`${theme.textMuted} text-sm`}>Create</span>
        </button>
      </div>
    </div>
  );
}

export default BrokerLinking;